function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { FormSelect } from '@uncinc/uncinc-react-kitchen-sink';
const SortBySelect = props => {
  const {
    placeholder,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(FormSelect, _extends({}, restProps, {
    fieldName: "sortBy",
    placeholder: placeholder,
    multiple: false,
    isClearable: false,
    isSearchable: false
  }));
};
export default SortBySelect;